// extracted by mini-css-extract-plugin
export default {"MultiSelectDropdown":"vhtw4hjK","PlaceholderMultiSelectDropdown":"RaeNof0c"};